module.exports = __webpack_public_path__ + "img/partner_img9.16782772.png";